const CnLayoutContent = (props) => {
    const { children } = props || {};
    return children;
};
CnLayoutContent.displayName = 'CnLayoutContent';
export default CnLayoutContent;
export { CnLayoutContent };
